// extracted by mini-css-extract-plugin
export default {"button":"PaymentMethod_button__aVhHX"};